import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { Skeleton } from 'ui/skeleton';

const Wrapper = styled.div`
  display: grid;
  grid-template-areas: 'name actions' 'description actions';
  row-gap: ${spacing.quarter};
  justify-content: space-between;
  padding: ${spacing.plusHalf};
`;

const NameSkeleton = styled(Skeleton)`
  grid-area: name;
`;

const DescriptionSkeleton = styled(Skeleton)`
  grid-area: description;
`;

const ActionsSkeleton = styled(Skeleton)`
  grid-area: actions;
`;

export const LoadingRows = () => (
  <>
    {[1, 2, 3].map((_, index) => (
      <Wrapper key={index}>
        <NameSkeleton height={20} width={240} />
        <DescriptionSkeleton height={20} width={410} />
        <ActionsSkeleton height={40} width={115} />
      </Wrapper>
    ))}
  </>
);
